import { useEffect as e, useRef as t, useState as n } from "react";
//#region src/components/overlays/useOverlayState.ts
function r(r, i) {
	let [a, o] = n(r.defaultOpen ?? !1), s = r.open ?? a, [c, l] = n(!1), [u, d] = n(null), [f, p] = n(!0), [m, h] = n(s);
	m !== s && (h(s), l(!1), d(null));
	let g = t(0), _ = t(!1);
	e(() => (g.current += 1, _.current = !1, () => {
		g.current += 1;
	}), [s]);
	let v = (e) => {
		o(e), r.onOpenChange?.(e);
	}, y = (e, t) => {
		if (t && p(!t.type.startsWith("key") && t.detail !== 0), e === "swipe" && !t && p(!0), _.current) return;
		if (!i?.beforeClose) {
			v(!1);
			return;
		}
		let n = g.current;
		_.current = !0, l(!0), d(null);
		let r = (e) => {
			n === g.current && (_.current = !1, l(!1), e && v(!1));
		}, a = (e) => {
			n === g.current && (_.current = !1, l(!1), d("Unable to close. Please try again."), i.onError?.(e));
		};
		try {
			let t = i.beforeClose(e);
			typeof t == "boolean" ? r(t) : t.then(r).catch(a);
		} catch (e) {
			a(e);
		}
	};
	return {
		open: s,
		pending: c,
		error: u,
		animate: f,
		requestClose: y,
		handleOpenChange: (e, t) => {
			p(!t.event.type.startsWith("key") && !(t.event instanceof MouseEvent && t.event.detail === 0)), e ? v(!0) : (t.cancel(), y(t.reason === "escape-key" || t.reason === "close-watcher" ? "escape" : t.reason === "outside-press" || t.reason === "focus-out" ? "outside" : t.reason === "trigger-press" ? "trigger" : "close"));
		}
	};
}
//#endregion
export { r as useOverlayState };
